"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalPlugin = exports.getModalManager = void 0;
const _ = __importStar(require("lodash"));
const modal_manager_1 = require("./modal-manager");
const modal_service_1 = require("./modal-service");
const PROP = '$imodal', PROP_PRIV = '__imodal';
function getModalManager(vm) {
    const service = _.get(vm, PROP_PRIV);
    return _.get(service, 'manager');
}
exports.getModalManager = getModalManager;
exports.ModalPlugin = {
    install(Vue, options) {
        const manager = new modal_manager_1.ModalManager();
        Vue.mixin({
            beforeCreate() {
                _.set(this, PROP_PRIV, new modal_service_1.ModalService(this, manager, options));
            }
        });
        if (!Vue.prototype.hasOwnProperty(PROP)) {
            Object.defineProperty(Vue.prototype, PROP, {
                get() {
                    if (!this || !this[PROP_PRIV]) {
                        console.warn(`"${PROP}" must be accessed from a Vue instance "this" context.`);
                    }
                    return this[PROP_PRIV];
                }
            });
        }
    }
};
//# sourceMappingURL=modal-plugin.js.map